import classNames from 'classnames'
import React from 'react'

//icon
import Icon from '../icon'
import Arrow from './icons/arrow.inline.svg'

//styles
import styles from './dropdown.module.scss'
interface IOptionType {
  label: string
  value: string
}

export interface DropdownProps {
  placeholder: string
  options: IOptionType[]
  onOptionClick?: (e: React.ChangeEvent<HTMLSelectElement>, optionValue: string) => void
  className?: string
  classNameIcon?: string
  value?: string
  wrapperClassName?: string
  srOnly?: string
  name?: string
}

const Dropdown = ({
  placeholder,
  onOptionClick,
  className,
  options,
  classNameIcon,
  value,
  wrapperClassName,
  srOnly,
  name = '',
}: DropdownProps) => {
  return (
    <label className={classNames(styles.dropdownWrapper, wrapperClassName)}>
      <span className="sr-only">{srOnly || placeholder}</span>
      <select
        id={placeholder}
        className={classNames(className, styles.dropdownWrapper__select)}
        onChange={e => {
          if (typeof onOptionClick === 'function') {
            onOptionClick(e, e.target.value)
          }
        }}
        value={value}
        name={name}
      >
        <option value={''} selected>
          {placeholder}
        </option>
        {options.length > 0 &&
          options.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
      </select>
      <Icon iconSvg={Arrow} className={classNames(classNameIcon, styles.dropdownIcon)} />
    </label>
  )
}

export default Dropdown
